(() => {
  const videos = document.querySelectorAll('.ep-home-deferred-video');

  if (!videos.length) return;

  const loadVideo = (video) => {
    const sources = video.querySelectorAll('source[data-src]');

    sources.forEach((source) => {
      source.src = source.dataset.src;
      source.removeAttribute('data-src');
    });

    if (sources.length) video.load();
  };

  if (!('IntersectionObserver' in window)) {
    videos.forEach((video) => {
      loadVideo(video);
      video.play().catch(() => {});
    });
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const video = entry.target;

      if (entry.isIntersecting) {
        loadVideo(video);
        video.play().catch(() => {});
      } else if (video.readyState > 0) {
        video.pause();
      }
    });
  }, {
    rootMargin: '500px 0px',
    threshold: 0.01
  });

  videos.forEach((video) => observer.observe(video));
})();
